/**
 * Event route registrations — wires context-specific event handlers into the eventRouter.
 *
 * Extracted from eventRouter.ts to decouple the router from context imports.
 * This file is imported eagerly by useEventSource.ts (client-side),
 * so registrations happen at module load time.
 */

import { eventRouter } from './eventRouter';
import { EVENT_TYPES } from './eventTypes';
import { registerSubscriptionEvents } from '@/contexts/subscriptions/events';
import { registerFamilyEvents } from '@/contexts/family/events';
import { registerStoriesEvents } from '@/contexts/stories/events';
import { registerIllustrationsEvents } from '@/contexts/illustrations/events';
import { registerCharacterEvents } from '@/contexts/characters/events';
import { registerMediaEvents } from '@/contexts/media/events';
import { registerPrintingEvents } from '@/contexts/printing/events';
import { registerAudioStoriesEvents } from '@/contexts/audio-stories/events';
import { registerContentEvents } from '@/contexts/content/events';
import { registerAIEvents } from '@/contexts/ai/events';
import { registerPipelineEvents } from '@/contexts/pipeline-v2/events';

const register = eventRouter.register.bind(eventRouter);

registerSubscriptionEvents(register);
registerFamilyEvents(register);
registerStoriesEvents(register);
registerIllustrationsEvents(register);
registerCharacterEvents(register);
registerMediaEvents(register);
registerPrintingEvents(register);
registerAudioStoriesEvents(register);
registerContentEvents(register);
registerAIEvents(register);
registerPipelineEvents(register);

// Workflow engine progress (WorkflowEventBridge → SSE). No cache invalidation —
// registering the type only guarantees SSE delivery to useEventSourceEvent
// listeners (useWorkflowRun) even before any listener mounts.
register(EVENT_TYPES.WORKFLOW.RUN_UPDATED, { getQueryKeys: () => [] });
